import { render, staticRenderFns } from "./budgetDimension.vue?vue&type=template&id=039ac972&scoped=true&"
import script from "./budgetDimension.vue?vue&type=script&lang=js&"
export * from "./budgetDimension.vue?vue&type=script&lang=js&"
import style0 from "./budgetDimension.vue?vue&type=style&index=0&id=039ac972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039ac972",
  null
  
)

export default component.exports